import styled from 'styled-components'

// components
import Row from '../Row'

export const RowColumn = styled(Row)`
  width: 1204px;
  flex-direction: column;
  ${({ theme }) => theme.mediaWidth.upToInfoLarge`
    width: 100%;
    padding: 0 10px;
  `}
`
export const RowColumnInfo = styled(Row)`
  padding: 48px 0;
  padding-bottom: 72px;
  align-items: flex-start;
  ${({ theme }) => theme.mediaWidth.upToMedium`
    flex-direction: column;
    align-items: center;
  `}
`
export const InfoImgLabel = styled(Row)`
  position: relative;
  margin-right: 40px;
  padding: 10px;
  width: 449px;
  /* width: 362px; */
  justify-content: center;
  flex-shrink: 0;
  height: 706px;
  border: 1px solid ${({ theme }) => theme.bsBg16};
  border-radius: 8px;
  box-sizing: border-box;
  align-items: center;
  box-sizing: border-box;
  ${({ theme }) => theme.mediaWidth.upToMedium`
    margin: 0 0 30px;
    width: 100%;
    max-width: 361px;
  `}
`
export const PriceFlag = styled.div`
  position: absolute;
  top: 0px;
  left: -6px;
  display: flex;
  align-items: center;
  background: ${({ theme }) => theme.bsBg8};
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
  box-shadow: ${({ theme }) => theme.darkMode ? 'none' : '0px 2px 8px rgba(47, 20, 0, 0.74)' };
  color: ${({ theme }) => theme.bsText1};
  font-family: Baloo Da;
  font-weight: 400;
  max-width: 100%;
  height: 28px;
  padding: 0 8px;
  z-index: 1;
  &:after {
    content: '';
    position: absolute;
    left: 0;
    bottom: -6px;
    border-width: 3px;
    border-style: solid;
    border-color: ${({ theme }) => theme.bsBg9} ${({ theme }) => theme.bsBg9} transparent transparent;
  }
`
export const InfoImg = styled.img`
  max-width: 100%;
  max-height: 100%;
  border-radius: 18px;
  object-fit: contain;
  cursor: pointer;
  overflow: hidden;
`
export const TextLabel = styled.div<{width?: string, height?: number, color?: string; family?: string; size?: number; top?: string; weight?: string}>`
  width: ${({width}) => (width ? width : 'auto')};
  line-height: ${({height}) => (height ? height : 28)}px;  
  color: ${({color}) => (color)};
  font-family: ${({family}) => (family ? family : 'Baloo Da')}!important;
  font-size: ${({size}) => (size ? size : 28)}px;
  margin: ${({top}) => (top ? top : 0)};
  font-weight: ${({weight}) => (weight ? weight : 'normal')};
`

export const TabRow = styled(Row)<{margin?: string, width?: string}>`
  margin: ${({margin}) => (margin ? margin : 'auto')};
  width: ${({width}) => (width ? width : 'auto')};
  justify-content: space-between;
  ${({ theme }) => theme.mediaWidth.upToInfoLarge`
    margin-bottom: 15px;
    flex-direction: column;
    align-items: center;
    width: auto;
  `}
`
export const BidTrad = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
`
export const InfoRight = styled(RowColumn)`
  align-items: flex-start;
  ${({ theme }) => theme.mediaWidth.upToMedium`
    align-items: center;
  `}
`
export const InfoDiv = styled.div`
  width: 100%;
  padding-bottom: 48px;
  min-height: 350px;
  border-bottom: 1px dashed rgba(214, 164, 133, 0.5);
  ${({ theme }) => theme.mediaWidth.upToMedium`
    height: auto;
    min-height: auto;
  `}
`
export const ArtworksList = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;

  ${({ theme }) => theme.mediaWidth.upToMedium`
    flex-wrap: nowrap;
    flex-direction: column;
    align-items: center;
    width: 100%;
    margin: 0px;
  `}
  .fourItem{
    &:not(:nth-child(3n)) {
      margin-right: 0px;
    }
    &:not(:nth-child(4n)) {
      margin-right: 12px;
    }
  }
  ${({ theme }) => theme.mediaWidth.upToMedium`
    .fourItem{
      &:not(:nth-child(4n)) {
        margin-right: 0px;
      }
    }
  `}
`
